module.exports = require("@babel/runtime-corejs3/helpers/objectWithoutProperties");